import { enqueueSnackbar } from 'notistack'

import { i18WithDefault as t } from '@shared/locale'
import { SMSConsentError } from 'components-ui/src/shared/error'
import { ClientLocationUserProfileService } from 'service-api/src/services/client_location_user_profiles.service'
import { ClientSMSConsentService } from 'service-api/src/services/client_sms_consent.service'
import { captureException } from 'service-api/src/shared/monitoring'
import type { TSMSConsentRequest } from 'service-api/src/types/general'

// Only confirmed opt-ins may lock the switch. Opt-outs are handled through STOP.
export const saveSMSConsent = async (
  locationName: string,
  contact: Omit<TSMSConsentRequest, 'consentType' | 'consentStatus'>
): Promise<boolean> => {
  try {
    const response = await ClientSMSConsentService.updateSMSConsent(locationName, {
      ...contact,
      consentType: 'SMS',
      consentStatus: 'ACTIVE',
    })
    // A successful HTTP request can still leave consent unconfirmed.
    const confirmed = response.success
      ? response.data.smsConsentStatus === 'ACTIVE'
      : (await ClientLocationUserProfileService.get(locationName, contact.lupId)).smsConsentStatus === 'ACTIVE'

    enqueueSnackbar(t(confirmed ? 'contactForm.smsConsent.success' : 'contactForm.smsConsent.notSaved'), {
      variant: confirmed ? 'success' : 'warning',
    })
    return confirmed
  } catch (error) {
    captureException(new SMSConsentError((error as Error).message), {
      context: { locationUserProfileId: contact.lupId },
    })
    enqueueSnackbar(t('contactForm.smsConsent.saveError'), {
      variant: 'error',
    })
    return false
  }
}
